import {HalfFloatType, NearestFilter, RepeatWrapping, Texture, WebGLRenderTarget} from "three";
import {CanvasService} from "features/apartmentViewer/ApartmentViewer/services/CanvasService";
import {LayerType} from "features/apartmentViewer/types";

export class Layer {
    public type: number;
    public isActive: boolean;
    public alpha: number;
    public renderTextureScaler: number;
    public needRender: boolean;
    protected _renderTexture: WebGLRenderTarget<Texture>;

    constructor(
        protected canvasService: CanvasService,
        layerType : number = LayerType.Default
    ) {
        this.type = layerType;

        this.renderTextureScaler = 1;
        this.isActive = true;
        this.alpha = 1;
        this.needRender = true;

    }

    getScaledCanvasSize() {
        const {width: t, height: e} = this.canvasService.getCurrentCanvasSize();


        return {
            width: Math.floor(t ? t * this.renderTextureScaler : 0),
            height: Math.floor(e * this.renderTextureScaler)
        }
    }

    get renderTexture(): WebGLRenderTarget {
        // Get the scaled canvas size (width and height)
        const { width, height } = this.getScaledCanvasSize();

        // Check if the existing render texture matches the desired width and height
        if (!this._renderTexture || this._renderTexture.width !== width || this._renderTexture.height !== height) {
            // If it doesn't match or doesn't exist, dispose of the old render texture
            if (this._renderTexture) {
                this._renderTexture.dispose();
            }

            // Create a new render texture with the desired size and properties
            this._renderTexture = new WebGLRenderTarget(width, height, {
                type: HalfFloatType,
                wrapS: RepeatWrapping,
                wrapT: RepeatWrapping,
                minFilter: NearestFilter,
                magFilter: NearestFilter,
            });

            // Indicate that a re-render is needed
            this.needRender = true;
        }

        // Return the (potentially new) render texture
        return this._renderTexture;
    }

    update() {
    }
}
